import React, { FC, SyntheticEvent } from "react";

import { Autocomplete, TextField } from "@mui/material";

import {
  IdentityProviders,
  IdentityProvidersLookup,
} from "./IdentityProviders";

type IdentityProviderSelectorProps = {
  readonly: boolean;
  value: string;
  onChange: (value: string) => void;
};

const IdentityProviderSelector: FC<IdentityProviderSelectorProps> = ({
  readonly,
  value,
  onChange,
}) => {
  function onSelectedChange(_event: SyntheticEvent, newValue: unknown) {
    onChange(`${newValue || ""}`);
  }

  return (
    <Autocomplete
      fullWidth
      disabled={readonly}
      disableClearable
      options={[""].concat(IdentityProviders.map((p) => p.id))}
      getOptionLabel={(option) =>
        IdentityProvidersLookup.get(option)?.name || ""
      }
      renderInput={(params) => <TextField {...params} />}
      value={value || ""}
      onChange={onSelectedChange}
      size="small"
    />
  );
};

export default IdentityProviderSelector;
